interface IconBookingStatusErrorOptions {
    cssClasses? : string
}

export function IconBookingStatusError(props : IconBookingStatusErrorOptions) {
    return (
        <svg id="ff222ea7-47d9-4cda-b1bd-2156914583cf" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={props?.cssClasses}>
            <defs>
                <clipPath id="aafde05b-9c5b-4e90-9847-1c3a9bad3209" transform="translate(0)">
                    <rect className="b856c44c-ce04-4ae3-9286-02016d92fa11" width="16" height="16"/>
                </clipPath>
            </defs>
            <g className="f4f48653-154a-4922-aaf6-58bb0619137c">
                <path className="a2e64cff-3155-4463-9277-01fe39a233b0" d="M5.33,11.33a.66.66,0,0,1-.47-1.13l5.33-5.34a.68.68,0,0,1,1,0,.66.66,0,0,1,0,.94L5.8,11.14A.66.66,0,0,1,5.33,11.33Z" transform="translate(0)"/>
                <path className="a2e64cff-3155-4463-9277-01fe39a233b0" d="M10.67,11.33a.66.66,0,0,1-.48-.19L4.86,5.8a.66.66,0,0,1,.94-.94l5.34,5.34a.66.66,0,0,1-.47,1.13Z" transform="translate(0)"/>
                <path className="a2e64cff-3155-4463-9277-01fe39a233b0" d="M8,16a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM8,1.33A6.67,6.67,0,1,0,14.66,8,6.67,6.67,0,0,0,8,1.33Z" transform="translate(0)"/>
            </g>
        </svg>
    );
}
